import React, { useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import AlterationForm from "../../model/AlterationForm";
import AlterationsList from "../alteration/AlterationsList";

interface IAlterationFormsListElementProps {
  data: AlterationForm;
  canEdit: boolean;
  onCreate: (
    name: string,
    type: string,
    idAlterationForm?: number | undefined
  ) => void;
  onUpdate: (name: string, id: number, type: string) => void;
  onDelete: (id: number, type: string) => void;
}

function AlterationFormsListElement({
  data,
  canEdit,
  onCreate,
  onUpdate,
  onDelete,
}: IAlterationFormsListElementProps) {
  // Local state for the editable name
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(data.name);

  // Toggle edit mode
  const handleEditClick = () => {
    if (!canEdit) return;
    setIsEditing(true);
  };

  const handleDelete = () => {
    if (!data.id) return;
    onDelete(data.id, "alteration_form");
  };

  // Handle saving the updated name
  const handleEdit = (e?: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e || e.key === "Enter") {
      setIsEditing(false);
      if (data.id && name != data.name) {
        onUpdate(name, data.id, "alteration_form");
      }
    }
  };

  return (
    <div className="alteration-form">
      <div className="alteration-form-title">
        {/* Left Column */}
        <div className="alteration-form-title-left">
          <p>Alteration Form:</p>
          {/* Toggle between text and input field */}
          {isEditing ? (
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onBlur={() => handleEdit()}
              onKeyDown={handleEdit}
              autoFocus
            />
          ) : (
            <h2 onClick={handleEditClick}>{data.name}</h2>
          )}
        </div>

        {/* Right Column */}
        {canEdit && (
          <div>
            <Button
              label="Edit"
              purpose={ButtonAction.EDIT}
              type={ButtonType.ICON}
              onClick={handleEditClick}
            />

            <Button
              label="Delete"
              purpose={ButtonAction.DELETE}
              type={ButtonType.ICON}
              onClick={handleDelete}
            />
          </div>
        )}
      </div>

      <div>
        <AlterationsList
          idAlterationForm={data.id}
          data={data.alterations!}
          canEdit={canEdit}
          onCreate={onCreate}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
}

export default AlterationFormsListElement;
